import { forwardRef } from 'react'

interface CenterProps extends React.HTMLAttributes<HTMLDivElement> {
    as?: React.ElementType
    inline?: boolean
    children?: React.ReactNode
}

export const Center = forwardRef<HTMLDivElement, CenterProps>(
    ({ as: Component = 'div', inline = false, className = '', children, ...props }, ref) => {
        return (
            <Component
                ref={ref}
                className={`${inline ? 'inline-flex' : 'flex'} items-center justify-center ${className}`}
                {...props}
            >
                {children}
            </Component>
        )
    }
)
